// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2R9fM","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2gCIX"};